import { dataToggle } from "../utils/toggle-dataset"
import { $Q, $Qll } from "../utils/query-selector"

function showZoomImage(parent, buttonImage) {
  const zoomImage = $Q('.variant__zoom--image', buttonImage);
  const modalZoom = $Q('.modal__information', parent);

  modalZoom.innerHTML = '<div class="spinner-container"><div class="spinner"></div></div>';
  modalZoom.innerHTML = zoomImage.innerHTML
}

/**
* show the zoom element in media query mobile
* @param {node} parent Parent of the input checket
* @author Andres Briñez
*/

export function showZoomMobile() {
  const zoom = $Qll('.zoom-toggle-js');
  const parent = $Q('.js-option:checked.option2');
  const zoomBtn = $Q('.zoom-toggle-js', parent?.parentNode);

  zoom.forEach((element) => {
    if (!element.classList.contains('modal__button')) {
      // eslint-disable-next-line no-param-reassign
      element.style.display = "none";
    }
  });

  if (zoomBtn) zoomBtn.style.display = "block"
}

/**
* Performs the opening and closing of the modal.
* Render the inside of the product for the modal
* @author Andres Briñez
*/

/**
* Function that opens and closes the modal
*/

export const openZoomModal = () => {
  const zoom = $Qll('.zoom-toggle-js');
  const modal = $Q('#zoom-modal-js');

  zoom.forEach((element) => {

    element.addEventListener(
      'click',
      () => {
        dataToggle(modal, true);
         console.log()

        if (element.classList.contains("variant__zoom")) {
          showZoomImage(modal, element);
        }
      },
    );
  });
}
